export const QUESTION_SET_RESULT = 'QUESTION_SET_RESULT'
export const QUESTION_SET_CURRENT = 'QUESTION_SET_CURRENT'
export const QUESTION_SET_LAST = 'QUESTION_SET_LAST'
export const QUESTION_GO_BACK = 'QUESTION_GO_BACK'

export function setQuestionResult(index, value) {
    return {
        type: QUESTION_SET_RESULT,
        index,
        payload: value,
    }
}

export function setCurrentQuestion(index) {
    // TODO: add garden knowledge to tracking params
    return {
        type: QUESTION_SET_CURRENT,
        payload: index,
        meta: {
            analytics: {
                eventType: 'interaction',
                eventPayload: {
                    interaction_value: index,
                    interaction_category: 'Intro-Questions',
                    interaction_action: 'question-view',
                    interaction_label: `question number ${index}`,
                },
            },
        },
    }
}

export function setPrevQuestion(index) {
    return {
        type: QUESTION_SET_LAST,
        payload: index,
    }
}

export function goQuestionBack(currentQuestionIndex) {
    // TODO: add garden knowledge to tracking params
    return {
        type: QUESTION_GO_BACK,
        payload: {},
        meta: {
            analytics: {
                eventType: 'interaction',
                eventPayload: {
                    interaction_value: currentQuestionIndex,
                    interaction_category: 'Intro-Questions',
                    interaction_action: 'back-clicked',
                    interaction_label: `${currentQuestionIndex}`,
                },
            },
        },
    }
}



// WEBPACK FOOTER //
// ./src/actions/questions.js